import { COUNTRY } from '@/config';

const isBrazil = COUNTRY === 'br';

export const STEPS = {
  CHOOSE_WP_MIGRATION: 'choose_wp_migration',
  CHOOSE_SITE_OPTION: 'choose_site_option',
  WORDPRESS_INSTALL: 'wordpress_install',
  SELECT_DOMAIN: 'select_domain',
  SUCCESS: 'success',
  BUY_DOMAIN: 'buy_domain',
  EXTERNAL_DOMAIN: 'external_domain',
  WORDPRESS_MIGRATION: 'wordpress_migration',

  IA_BUILDER_CREATE_SITE: 'ia_builder_create_site',
  IA_BUILDER_WITH_TEMPLATE: 'ia_builder_with_template',
  IA_BUILDER_MY_BUSINESS: 'ia_builder_my_business',
  SITE_BUILDER_V2: 'site_builder_v2',
  SITE_BUILDER_PREVIEW: 'site_builder_preview',
};

export const FLOWS = {
  WORDPRESS: 'WORDPRESS',
  WORDPRESS_IA: 'WORDPRESS_IA',
  SITE_BUILDER: 'SITE_BUILDER',
  SITE_BUILDER_V2: 'SITE_BUILDER_V2',
  OTHER_TOOLS: 'OTHER_TOOLS',
  AGENT_FACTORY: 'AGENT_FACTORY',
  WORDPRESS_MIGRATION: 'WORDPRESS_MIGRATION',
};

const brPlans = {
  planoP: 5,
  planoM: 6,
  planoStarter: 437,
  planoTurbo: 335,
  planoBusiness: 7,
  hospedagemPlus: 47,
  hospedagemColaboradoresInternos: 247,
  criadorSitesPessoal: 278,
  criadorSitesProfissional: 284,
  criadorSitesLojaOnline: 272,
  revenda1: 50,
  revenda2: 51,
  revenda3: 52,
  revenda4: 53,
  revenda5: 54,
  revendaComecando: 385,
  revendaCrescendo: 388,
  revendaExpandindo: 391,
  revendaVeterano: 394,
  revendaVeterano100: 397,
  revendaVeterano150: 409,
  revendaVeterano200: 400,
  revendaVeterano300: 403,
  revendaVeterano500: 406,
  revendaVeterano1000: 412,
  revendaVeterano1200: 415,
};

const esPlans = {
  planPersonal: 174,
  planEmpreendedor: 5,
  planNegocios: 6,
  planProfessional: 7,
  planTurbo: 213,
  creadorSitiosPersonal: 164,
  creadorSitiosProfessional: 165,
  creadorSitiosTiendEnLinea: 166,
  resellerCobre: 51,
  resellerPlata: 52,
  resellerOro: 53,
  resellerDiamante: 54,
  resellerAluminio: 50,
  resellerIniciando: 229,
  resellerCreciendo: 230,
  resellerExpandiendo: 231,
  resellerVeterano: 232,
  resellerVeterano100: 233,
  resellerVeterano150: 234,
  resellerVeterano200: 235,
  resellerVeterano300: 236,
  resellerVeterano500: 237,
  resellerVeterano1000: 240,
  resellerVeterano1200: 238,
};

const siteBuilderPlansIds = isBrazil
  ? [brPlans.criadorSitesPessoal, brPlans.criadorSitesProfissional, brPlans.criadorSitesLojaOnline]
  : [esPlans.creadorSitiosPersonal, esPlans.creadorSitiosProfessional, esPlans.creadorSitiosTiendEnLinea];

export const singleDomainsPlansIds = isBrazil
  ? [brPlans.planoP, brPlans.planoStarter, brPlans.hospedagemPlus, brPlans.hospedagemColaboradoresInternos, ...siteBuilderPlansIds]
  : [esPlans.planPersonal, esPlans.planEmpreendedor, ...siteBuilderPlansIds];

export const multiDomainsPlansIds = isBrazil
  ? [brPlans.planoM,
    brPlans.planoBusiness,
    brPlans.planoTurbo,
    brPlans.hospedagemColaboradoresInternos,
    brPlans.revenda1,
    brPlans.revenda2,
    brPlans.revenda3,
    brPlans.revenda4,
    brPlans.revenda5,
    brPlans.revendaComecando,
    brPlans.revendaCrescendo,
    brPlans.revendaExpandindo,
    brPlans.revendaVeterano,
    brPlans.revendaVeterano100,
    brPlans.revendaVeterano150,
    brPlans.revendaVeterano200,
    brPlans.revendaVeterano300,
    brPlans.revendaVeterano500,
    brPlans.revendaVeterano1000,
    brPlans.revendaVeterano1200,
  ]
  : [
    esPlans.planTurbo,
    esPlans.planNegocios,
    esPlans.planProfessional,
    esPlans.resellerCobre,
    esPlans.resellerPlata,
    esPlans.resellerOro,
    esPlans.resellerDiamante,
    esPlans.resellerAluminio,
    esPlans.resellerIniciando,
    esPlans.resellerCreciendo,
    esPlans.resellerExpandiendo,
    esPlans.resellerVeterano,
    esPlans.resellerVeterano100,
    esPlans.resellerVeterano150,
    esPlans.resellerVeterano200,
    esPlans.resellerVeterano300,
    esPlans.resellerVeterano500,
    esPlans.resellerVeterano1000,
    esPlans.resellerVeterano1200,
  ];
